import styled from 'styled-components';
import { grid, GridProps } from 'styled-system';

export const TitleWrapper = styled.div<GridProps>`
  display: flex;
  align-items: center;
  ${grid};
`;
